var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "23px",
    viewBox: "0 0 25 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.99255174 C0,2.23524155 2.24705092,0 4.99866122,0 L18.4363867,0 C21.1970711,0 23.435048,2.24111271 23.435048,4.99255174 L23.435048,12.8452861 C23.435048,15.6025963 21.1983728,17.8378378 18.4337946,17.8378378 L14.9221066,17.8378378 L14.9221066,22 L8.78814298,17.8378378 L4.99741504,17.8378378 C2.23741892,17.8378378 0,15.5967251 0,12.8452861 L0,4.99255174 Z M17.576286,10.7027027 C18.5469974,10.7027027 19.3339146,9.9040755 19.3339146,8.91891892 C19.3339146,7.93376234 18.5469974,7.13513514 17.576286,7.13513514 C16.6055745,7.13513514 15.8186574,7.93376234 15.8186574,8.91891892 C15.8186574,9.9040755 16.6055745,10.7027027 17.576286,10.7027027 Z M5.85876199,10.7027027 C6.82947346,10.7027027 7.61639058,9.9040755 7.61639058,8.91891892 C7.61639058,7.93376234 6.82947346,7.13513514 5.85876199,7.13513514 C4.88805052,7.13513514 4.10113339,7.93376234 4.10113339,8.91891892 C4.10113339,9.9040755 4.88805052,10.7027027 5.85876199,10.7027027 Z M11.717524,10.7027027 C12.6882354,10.7027027 13.4751526,9.9040755 13.4751526,8.91891892 C13.4751526,7.93376234 12.6882354,7.13513514 11.717524,7.13513514 C10.7468125,7.13513514 9.95989538,7.93376234 9.95989538,8.91891892 C9.95989538,9.9040755 10.7468125,10.7027027 11.717524,10.7027027 Z",
    id: "comment-path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.1%",
    y: "-2.3%",
    width: "108.5%",
    height: "109.1%",
    filterUnits: "objectBoundingBox",
    id: "comment-filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163.000000, -233.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#comment-filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#comment-path-1"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.79861650.svg";
export { ForwardRef as ReactComponent };